import Vue from 'vue'
import axios from 'axios';
import _ from 'lodash';

export const STATUS_NEW = 10;
export const STATUS_READ = 20;

export default {
    state: {
        alerts: [],
    },
    mutations: {
        fetchAlerts(state, payload) {
            state.alerts = payload;
        },
        setAlerts(state, payload) {
            state.alerts = payload;
        },
        editAlert(state, payload) {
            const index = state.alerts.findIndex(item => item.id === payload.id);
            Vue.set(state.alerts, index, payload);
        },
        addAlert(state, payload) {
            state.alerts.unshift(payload);
        },
        allReadedAlerts(state) {
            Object.keys(state.alerts).forEach(key => {
                state.alerts[key].status = STATUS_READ;
            })
        }
    },

    actions: {
        async fetchAlerts({ commit, dispatch }) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.get(`${this._vm.appConfig.app_url}/api/alert`, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('fetchAlerts', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if(errors.status == 401){
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async allReadedAlerts({commit, dispatch}) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.post(`${this._vm.appConfig.app_url}/api/alert/all-readed`, {}, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                if (!data.success) {
                    console.log(data);
                    return; //!? exception
                }

                commit('setLoading', false);
                commit('allReadedAlerts');
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
        async editAlert({commit, dispatch}, payload) {
            commit('clearError')
            commit('setLoading', true);

            let user = JSON.parse(localStorage.getItem("user"));
            try {
                let { data } = await axios.put(`${this._vm.appConfig.app_url}/api/alert/${payload.id}`, payload, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        "Authorization": `Bearer ${user.access_token}`
                    }
                });

                commit('setLoading', false);
                commit('editAlert', data);
            } catch(error) {
                commit('setLoading', false);

                if (error.response) {
                    let errors = error.response;
                    if (errors.status == 401) {
                        dispatch('logOutUser');
                        window.location.reload();
                    }
                    if(errors.status == 400) {
                        dispatch('setError', _.values(errors.data)[0][0]);
                        return Promise.reject(errors.data);
                    }
                }

                if (error.message) {
                    dispatch('setError', error.message);
                } else {
                    dispatch('setError', error);
                }
            }
        },
    },

    getters: {
        alerts (state) {
            return state.alerts
        },
    }
}